import React, {Component} from 'react';
import Modal from 'react-bootstrap-modal';
import {t} from 'l10n';

// Shown on /membre/ after following the email change confirmation link
// (backend www/member/validate_email.php redirects with ?email_change=<status>).
// Only known status values are displayed, as fixed translated strings.
export const EMAIL_CHANGE_STATUSES = ['confirmed', 'invalid'];

class ModalEmailChangeResult extends Component {
    render() {
        const {status, closeFn} = this.props;

        const message = status === 'confirmed'
            ? t('Your new email address has been saved.')
            : t('The link you have used is not valid anymore.');

        return (
            <Modal className="change-email" show={true} onHide={closeFn}>
                <Modal.Body>
                    <div className="close" onClick={closeFn}></div>
                    <p className="modal-title">{t('Change email')}</p>
                    <div className="form">
                        <div className="form-group">
                            <label>{message}</label>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

export default ModalEmailChangeResult;



// WEBPACK FOOTER //
// ./src/components/modals/ModalEmailChangeResult.js